const roles = [
    { value: 'viewer', label: 'Viewer', description: 'View only' },
    { value: 'editor', label: 'Editor', description: 'Edit scenarios' },
    { value: 'admin', label: 'Admin', description: 'Full access' },
];

const RoleSelector = ({ value, onChange }) => {
    return (
        <div className="role-selector">
            {roles.map((role) => (
                <label
                    key={role.value}
                    className={`role-selector__option ${value === role.value ? 'role-selector__option--active' : ''}`}
                    onClick={() => onChange(role.value)}
                >
                    <input
                        type="radio"
                        name="role"
                        value={role.value}
                        checked={value === role.value}
                        onChange={() => onChange(role.value)}
                        className="form__field--checkbox"
                    />
                    <span className="role-selector__label">{role.label}</span>
                    <span className="role-selector__desc">{role.description}</span>
                </label>
            ))}
        </div>
    );
};

export default RoleSelector;
